import { createModule } from '../../createModule';
export const createClientPricingAPI = createModule(({ http }) => {
    return {
        getClients: async () => {
            const res = await http.get('/v2/client-pricing/clients');
            return res;
        },
        getProducts: async (params) => {
            const res = await http.get('/v2/client-pricing/products', {
                params,
            });
            return res;
        },
        getDataPresence: async () => {
            const res = await http.get('/v2/client-pricing/data-presence');
            return res;
        },
        // ---
        createClient: async (body) => {
            const res = await http.post('/v2/client-pricing/client', { body: body });
            return res;
        },
        updateClient: async (body) => {
            const res = await http.patch('/v2/client-pricing/client', { body: body });
            return res;
        },
        // ---
        createProduct: async (body) => {
            const res = await http.post('/v2/client-pricing/product', { body: body });
            return res;
        },
        updateProduct: async (body) => {
            const res = await http.patch('/v2/client-pricing/product', { body: body });
            return res;
        },
        addProductToClient: async (body) => {
            const res = await http.post(`/v2/client-pricing/product/${body.product_id}/client/${body.client_id}`);
            return res;
        },
        deleteProductFromClient: async (body) => {
            const res = await http.delete(`/v2/client-pricing/product/${body.product_id}/client/${body.client_id}`);
            return res;
        },
        deleteProduct: async (body) => {
            const res = await http.delete(`/v2/client-pricing/product/${body.product_id}`);
            return res;
        },
        deleteProductMappings: async (body) => {
            const res = await http.delete(`/v2/client-pricing/product/${body.product_id}`);
            return res;
        },
        // ---
        sendEmailToClient: async (body) => {
            const res = await http.post('/v2/client-pricing/email', { body: body });
            return res;
        },
        v2: {
            getDataPresence: async () => {
                const res = await http.get('/v2/client-pricing/v2/data-presence');
                return res;
            },
            getClients: async () => {
                const res = await http.get('/v2/client-pricing/v2/clients');
                return res;
            },
            getClientProducts: async (params) => {
                const url = params.client_id
                    ? `/v2/client-pricing/v2/client/${params.client_id}/products`
                    : `/v2/client-pricing/v2/clients/products`;
                const res = await http.get(url);
                return res;
            },
            updateClient: async (body) => {
                const org_id = body.rowData.org_id;
                const res = await http.patch(`/v2/client-pricing/v2/client/${org_id}`, {
                    body: body,
                });
                return res;
            },
            addProductToClient: async (params) => {
                const { org_id, instrument_id } = params;
                const res = await http.post(`/v2/client-pricing/v2/client/${org_id}/products`, {
                    body: {
                        instrument_id,
                    },
                });
                return res;
            },
            removeProductFromClient: async (params) => {
                const { org_id, instrument_id } = params;
                const res = await http.delete(`/v2/client-pricing/v2/client/${org_id}/products/${instrument_id}`);
                return res;
            },
            deleteProductMappings: async (params) => {
                const { instrument_id } = params;
                const res = await http.delete(`/v2/client-pricing/v2/product-mappings/${instrument_id}`);
                return res;
            },
            sendEmailToClients: async (body) => {
                const res = await http.post('/v2/client-pricing/v2/email', { body: body });
                return res;
            },
        },
    };
});
